import { FiHome, FiInfo, FiPhone } from "react-icons/fi";

const NavbarVariant1 = ({ theme, font, editableData = {}, renderEditable }) => {
  // Helper to get text value safely
  const getText = (key, defaultValue) => {
    const value = editableData[key];
    return typeof value === 'string' ? value : value?.text || defaultValue;
  };

  return (
    <nav className="w-full py-3 px-6 flex justify-between items-center border-b border-gray-100 bg-gray-50">
      <div
        className="text-lg font-bold tracking-wide"
        style={{ color: theme.primaryColor, fontFamily: font.mainText }}
      >
        {renderEditable ? 
          renderEditable("logo", getText("logo", "Logo")) : 
          getText("logo", "Logo")
        }
      </div>
      <div className="flex items-center space-x-6 text-sm">
        <a
          href="#"
          className="flex items-center gap-1 hover:opacity-75"
          style={{ color: theme.textColor }}
        >
          <FiHome />
          {renderEditable ? 
            renderEditable("page_1", getText("page_1", "Home")) : 
            getText("page_1", "Home")
          }
        </a>
        <a
          href="#"
          className="flex items-center gap-1 hover:opacity-75"
          style={{ color: theme.textColor }}
        >
          <FiInfo />
          {renderEditable ? 
            renderEditable("page_2", getText("page_2", "About")) : 
            getText("page_2", "About")
          }
        </a>
        <a
          href="#"
          className="flex items-center gap-1 hover:opacity-75"
          style={{ color: theme.textColor }}
        >
          <FiPhone />
          {renderEditable ? 
            renderEditable("page_3", getText("page_3", "Contact")) : 
            getText("page_3", "Contact")
          }
        </a>
      </div>
    </nav>
  );
};

export default NavbarVariant1;